'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CdsImage = require('./CdsImage');

var _reactImageGallery = require('react-image-gallery');

var _reactImageGallery2 = _interopRequireDefault(_reactImageGallery);

var _reactRouterDom = require('react-router-dom');

var _redux = require('redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CdsSlider = (_temp = _class = function (_React$Component) {
	_inherits(CdsSlider, _React$Component);

	function CdsSlider(props) {
		_classCallCheck(this, CdsSlider);

		var _this = _possibleConstructorReturn(this, (CdsSlider.__proto__ || Object.getPrototypeOf(CdsSlider)).call(this, props));

		_this.state = {
			loading: true
		};
		return _this;
	}

	_createClass(CdsSlider, [{
		key: 'handleOnLoaded',
		value: function handleOnLoaded() {
			this.setState({ loading: false });
		}
	}, {
		key: 'parseImages',
		value: function parseImages(item) {
			var IMAGES = item.IMAGES;
			var searchOrder = [this.props.activeLanguage, "ALL", "EN", "DE", "FR"];
			/* SELECT CAPTION */

			var URL = null;
			var IMAGE = null;
			var CAPTION = null;

			searchOrder.map(function (searchLC) {
				if (IMAGE == null && IMAGES.hasOwnProperty(searchLC)) {
					IMAGE = IMAGES[searchLC];
				}
			});

			if (IMAGE != null) {
				searchOrder.map(function (searchLC) {
					if (CAPTION == null && IMAGE.CAPTION.hasOwnProperty(searchLC)) {
						CAPTION = IMAGE.CAPTION[searchLC];
					}
				});
			}

			return {
				ASSET_TYPE: "SLIDER",
				URL_TYPE: "CDS",
				URL: IMAGE.URL,
				CAPTION: CAPTION
			};
		}
	}, {
		key: 'getItems',
		value: function getItems() {
			var _this2 = this;

			var options = {
				original: {
					width: this.props.width,
					height: this.props.height,
					watermark: this.props.watermark
				},
				thumbnail: {
					width: this.props.thumbWidth,
					height: this.props.thumbHeight
				}
			};

			return Object.values(this.props.sliderData).map(function (item) {
				// todo selection per activeLanguage
				var PICTURE_ASSET = _this2.parseImages(item);
				return {
					original: (0, _CdsImage.getPicParams)(Object.assign({}, options.original, { asset: PICTURE_ASSET })).url,
					originalAlt: PICTURE_ASSET.CAPTION,
					thumbnail: (0, _CdsImage.getPicParams)(Object.assign({}, options.thumbnail, { asset: PICTURE_ASSET })).url,
					thumbnailAlt: PICTURE_ASSET.CAPTION
				};
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var items = this.getItems();

			var newProps = Object.assign({}, this.props, {
				items: items,
				onClick: this.onClick.bind(this)
			});

			return _react2.default.createElement(_reactImageGallery2.default, _extends({}, newProps, { ref: "gallery" }));
		}
	}, {
		key: 'onClick',
		value: function onClick() {
			var currentIndex = this.refs.gallery.getCurrentIndex();
			var URL = this.props.sliderData[currentIndex].LINK.URL.toString();
			var URL_TYPE = this.props.sliderData[currentIndex].LINK.URL_TYPE;

			switch (URL_TYPE) {
				case "product":
					this.props.history.push("product/" + URL);
					break;
				case "category":
					this.props.history.push("category/" + URL);
					break;
				case "manufacturer":
					this.props.history.push("manufacturer/" + URL);
					break;
				case "search":
					this.props.history.push("search?q=" + URL);
					break;
				case "sales":
					this.props.history.push("sales");
					break;
				case "sale":
					this.props.history.push("sales?sale_name=" + URL);
					break;
				case "external":
					window.open(URL, '_blank').focus();
					break;
				default:
					break;
			}
		}
	}]);

	return CdsSlider;
}(_react2.default.Component), _class.propTypes = {
	sliderData: _propTypes2.default.any,
	width: _propTypes2.default.number,
	height: _propTypes2.default.number,
	thumbWidth: _propTypes2.default.number,
	thumbHeight: _propTypes2.default.number,
	lazyLoad: _propTypes2.default.bool,
	showFullscreenButton: _propTypes2.default.bool,
	showPlayButton: _propTypes2.default.bool,
	showBullets: _propTypes2.default.bool,
	useTranslate3D: _propTypes2.default.bool,
	autoPlay: _propTypes2.default.bool,
	showThumbnails: _propTypes2.default.bool,
	watermark: _propTypes2.default.bool,
	onClick: _propTypes2.default.any,
	bulletClass: _propTypes2.default.string,
	additionalClass: _propTypes2.default.string,
	slideInterval: _propTypes2.default.number,
	activeLanguage: _propTypes2.default.string
}, _class.defaultProps = {
	width: 600,
	height: 400,
	thumbWidth: 160,
	thumbHeight: 120,
	lazyLoad: false,
	showFullscreenButton: false,
	showPlayButton: false,
	showBullets: false,
	useTranslate3D: false,
	autoPlay: false,
	showThumbnails: false,
	watermark: false,
	bulletClass: "slider-bullet",
	additionalClass: "CdsSlider",
	slideInterval: 6000,
	activeLanguage: "EN"
}, _temp);
exports.default = (0, _redux.compose)(_reactRouterDom.withRouter)(CdsSlider);